import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import loadable from '@loadable/component';
// import { Loader } from '../../../../common/components';
// import ListPunchInOutPage from '../ListPunchInOutPage';
// import EditPunchInOutPage from '../EditPunchInOutPage';
// import ViewPunchInOutPage from '../ViewPunchInOutPage';
import ListDatabasePage from '../../../Projects/Database/ListDatabasePage';
import ListPage from './ListPage';
// const ListDatabasePage = loadable(() => import('./ListDatabasePage'), {
//     fallback: <Loader/>,
// });
const OwnRoutes = ({ t, updateSelectedTab, alert }) => {
  return [
    <Route
      key="own_record_list"
      exact
      path="/own"
      element={<ListPage t={t} updateSelectedTab={updateSelectedTab} alert={alert} />}
    />
    // <Route index exact path="/list" element={<ListPunchInOutPage t={t} />} />,
    // <Route index exact path="/edit/:id" element={<EditPunchInOutPage t={t} />} />,
    // <Route index exact path="/view/:id" element={<ViewPunchInOutPage t={t} />} />,
  ];
};
OwnRoutes.propTypes = {
  t: PropTypes.func
};
export default OwnRoutes;
